import { render } from "./ServicesDirectorySidebar.vue?vue&type=template&id=1d37072b&scoped=true"
import script from "./ServicesDirectorySidebar.vue?vue&type=script&lang=js"
export * from "./ServicesDirectorySidebar.vue?vue&type=script&lang=js"

import "./ServicesDirectorySidebar.vue?vue&type=style&index=0&id=1d37072b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d37072b"]])

export default __exports__